<template>
  <div class="d-grid custom-grid">
    <span @mousedown="onMouseDown" class="revo-draggable">
      <span class="revo-drag-icon"/>
    </span>
    <span class="grid-end-x">{{ valueToDraw }}</span>
    <span @click="onClickIndicator" :class="indicator.class" class="grid-end-x">
      {{ indicator.symbol }}
    </span>
    <v-btn icon :color="isVisibleColor" @click="onClickIsVisible" x-small class="align-self-center grid-end-x">
      <v-icon>mdi-eye</v-icon>
    </v-btn>
    <div class="align-self-center" :style="cellLineThrough"/>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { EventBus } from '../../../helpers/eventBus';

@Component
export default class MenuCell extends Vue {
  @Prop({ type: String, required: true, default: null }) prop;

  @Prop({ type: Object, required: true, default: null }) model;

  get valueToDraw() {
    return this.model[this.prop];
  }

  get indicator() {
    return this.model[`${this.prop}_special`] ? { symbol: '★', class: '' } : { symbol: '☆', class: '' };
  }

  get revoData() {
    return this.$el.closest('revogr-data');
  }

  get isVisible() {
    return this.model[`${this.prop}_is_visible`];
  }

  get isVisibleColor() {
    return this.isVisible ? 'primary' : 'normal';
  }

  get cellLineThrough() {
    return {
      ...(!this.isVisible && { border: '1px solid grey', width: '100%', position: 'absolute' }),
    };
  }

  onMouseDown(e) {
    this.revoData?.dragStartCell.emit(e);
  }

  onClickIndicator() {
    this.model[`${this.prop}_special`] = !this.model[`${this.prop}_special`];
    EventBus.$emit('special', {
      mpddGuid: this.model[`${this.prop}_guid`],
      newValue: this.model[`${this.prop}_special`],
      prop: this.prop,
    });
  }

  onClickIsVisible() {
    this.model[`${this.prop}_is_visible`] = !this.model[`${this.prop}_is_visible`];
    EventBus.$emit('isVisible', {
      mpddGuid: this.model[`${this.prop}_guid`],
      newValue: this.model[`${this.prop}_is_visible`],
      prop: this.prop,
    });
  }
}

</script>
<style>
.custom-grid {
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0 0;
  position: relative
}
.tooltiptext-outside {
  box-shadow: inset 0px 0px 50px 50px #ff5e5e;
  text-align: center;
  border-radius: 6px;
  opacity: 0;
  /* Position the tooltip */
  position: absolute;
  left: -10px;
  transition: 0.3s;
  z-index: -1;
}
.error-cell-outside:hover .tooltiptext-outside {
  opacity: 1;
  transition: 0.5s;
  z-index: 1;
}
</style>
